/**
 * Featured Product Categories Widget JS
 *
 * @since   1.0.0
 * @package premier
 */
(function($) {
    // Hook for when elementor front end is loaded
    $(window).on('elementor/frontend/init', function() {
        //hook name is 'frontend/element_ready/{widget-name}.{skin}
        //$scope is a jquery wrapped parent element
        elementorFrontend.hooks.addAction('frontend/element_ready/featured-product-categories.default', function($scope) {

			var reduceFontSizeForLongTitles = (function() {

				var init = function() {
					var titles = document.querySelectorAll('.card-inner h2');
					for (var i = 0; i < titles.length; i++) {
						if (titles[i].innerText.length > 24) {
							titles[i].classList.add('shrink-text');
						}
					}
				};

				return {
					init: init
				};
			})();


			// reduce the font size for longer card titles
			reduceFontSizeForLongTitles.init();

        });
    });

})(jQuery);
